import React, { useEffect, useState, useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import Quiz, { QuizItem, AnswerItem } from "../components/Quiz";
import { getQuizTopics } from "../services/courseDetailService";
// @ts-ignore
import { NavigateNullMsisdn } from "../utils/CommonFunction";

export interface QuizScreenProps {
  token?: string;
  loaderStatus: (status: boolean) => void;
}

const QuizScreen: React.FC<QuizScreenProps> = (props) => {
  const [searchParams] = useSearchParams();
  const [topicId] = useState<number>(
    parseInt(searchParams.get("topicId") || "0", 10),
  );
  const [title] = useState<string>("Quiz");
  const [quiz, setQuiz] = useState<QuizItem[]>([]);
  const [answers, setAnswers] = useState<Record<string, AnswerItem>>({});
  const [showAns, setShowAns] = useState<boolean>(false);
  const [passed, setPassed] = useState<boolean>(false);

  const getQuizData = useCallback(async () => {
    try {
      const data = await getQuizTopics(topicId, props.token);
      if (data && data.status === 200) {
        setQuiz(data.response || []);
      }
    } catch (error) {
      console.warn("getQuizData error", error);
    } finally {
      props.loaderStatus(true);
    }
  }, [topicId, props]);

  const checkAnswers = useCallback(async () => {
    if (Object.keys(answers).length !== quiz.length) {
      Swal.fire("alert", "Please select answers of all questions", "warning");
    } else {
      const _ans: (string | number)[] = [];
      quiz.forEach((item) => {
        item.answers.forEach((element) => {
          if (answers[item.id]?.id === element.id) {
            if (element.isCorrect) {
              _ans.push(element.id);
            }
          }
        });
      });
      if (_ans.length === quiz.length) {
        Swal.fire("Congratulations", "You have passed the test", "success");
        setPassed(true);
      } else {
        setPassed(false);
      }
      setShowAns(true);
    }
  }, [answers, quiz]);

  const selectChange = useCallback((e: AnswerItem, item: QuizItem) => {
    setAnswers((prevState) => ({ ...prevState, [item.id]: e }));
  }, []);

  useEffect(() => {
    NavigateNullMsisdn();
    document.title = title;
    if (props.token !== null) {
      props.loaderStatus(false);
      getQuizData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, props.token]);

  return (
    <Quiz
      quiz={quiz}
      answers={answers}
      showAns={showAns}
      passed={passed}
      selectChange={selectChange}
      checkAnswers={checkAnswers}
    />
  );
};

export default QuizScreen;
